import Image from 'next/image';
import { Typography } from '@bgzt/ui';

import noticeIconUrl from '~/public/assets/icons/ic_notice.svg?url';
import { Spacing, Flex } from '~/components';
import { getPaymentNotices } from '~/utils/shop-service';

import styles from './noticeCard.module.css';
import { ShopId } from '~/constants/shop';

type Props = {
  shopId?: ShopId;
};
export const NoticeCard = ({ shopId }: Props) => {
  return (
    <div className={styles['container']}>
      <Flex align="center">
        <Image src={noticeIconUrl} alt="" width={20} height={20} />
        &nbsp;
        <Typography variant="L7" color="gray-800">
          결제 전 확인해 주세요
        </Typography>
      </Flex>

      <Spacing height={11} />

      <ul
        style={{
          display: 'flex',
          flexDirection: 'column',
          rowGap: '4px',
        }}
      >
        {getPaymentNotices(shopId as ShopId).map((value, i) => {
          return (
            <li key={`notice_${i}`}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  columnGap: '6px',
                }}
              >
                <Typography variant="L12" color="gray-600">
                  •
                </Typography>

                <Typography variant="L12" color="gray-500">
                  {value}
                </Typography>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
